<template>
  <div
    :class="
      data.bg
        ? 'alternate-header-container'
        : data.bg2
        ? 'alternate-header-container-small'
        : data.bg4
        ? 'alternate-header-container-smaller'
        : 'alternate-header-container-full'
    "
    :style="{
      'background-image': `url(${data.bg || data.bg2 || data.bg3 || data.bg4})`,
    }"
  >
    <headerMenu />
    <div class="header-cta-section">
      <div class="alternate-header-cta-wrapper">
        <div class="row w-100">
          <div class="row p-0">
            <div class="col-lg-6 col-12 alternate-header-section-left">
              <div class="alternate-header-breadcrumbs">
                <i
                  class="mdi mdi-arrow-left alternate-header-back"
                  @click="$router.back()"
                ></i>
                <v-breadcrumbs
                  :items="items"
                  divider=">"
                  class="m-0"
                ></v-breadcrumbs>
              </div>
              <div class="alternate-header-frames-mobile">
                <img
                  v-if="data.frame4"
                  :src="data.frame4"
                  class="alternate-dual-bg-right-frame-1-mobile"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame5"
                  :src="data.frame5"
                  class="alternate-dual-bg-right-frame-2-mobile"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame6"
                  :src="data.frame6"
                  class="alternate-dual-bg-right-frame-3"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame7"
                  :src="data.frame7"
                  class="alternate-dual-bg-right-frame-5-mobile"
                  alt="Frame image"
                />
                <img
                  v-if="data.bgInner3"
                  :src="data.bgInner3"
                  class="alternate-dual-bg-right-img-1-mobile"
                  alt="background image"
                />
                <img
                  v-if="data.bgInner2"
                  :src="data.bgInner2"
                  class="alternate-dual-bg-right-img-mobile"
                  alt="background image"
                />
                <img
                  v-if="data.bgInner5"
                  :src="data.bgInner5"
                  class="alternate-bg-right-img-mobile-map"
                  alt="background image"
                />
              </div>
              <div class="alternate-header-section-left-inner">
                <div class="header-title">
                  <h1>{{ data.title1 }}</h1>
                </div>
                <div class="header-title" :class="data.titleClass">
                  <h2 class="header-title-h2">{{ data.title2 }}</h2>
                </div>
                <div class="header-subtitle">
                  {{ data.desc1 }}
                </div>
                <div class="header-subtitle">
                  {{ data.desc2 }}
                </div>
                <div class="header-subtitle">{{ data.desc3 }}</div>
                <div class="header-subtitle-individuals">
                  {{ data.desc4 }}
                  <p v-if="data.desc5">{{ data.desc5 }}</p>
                </div>
                <div class="header-buttons">
                  <md-filled-tonal-button
                    v-if="data.button1"
                    class="get-started-button"
                    @click="
                      $router.push(
                        $route.path.includes('for-individuals')
                          ? '/book-demo'
                          : '/try-comligo-for-free'
                      )
                    "
                  >
                    {{ data.button1 }}
                    <i class="mdi mdi-arrow-right"></i>
                  </md-filled-tonal-button>
                  <md-outlined-button
                    v-if="data.button2"
                    class="discover-more-button"
                    @click="goToDiv(data.scrollElement)"
                    >{{ data.button2 }}</md-outlined-button
                  >
                </div>
                <div
                  v-if="data.desc6"
                  class="header-spacer individual-header-subtitle"
                >
                  {{ data.desc6 }}
                </div>
                <div v-if="data.spacer" :style="{ height: data.spacer }"></div>
              </div>
            </div>
            <div class="col-lg-6 col-12 alternate-header-section-right">
              <img
                v-if="data.bgInner"
                :src="data.bgInner"
                class="alternate-bg-right-img"
                alt="background image"
              />
              <img
                v-if="data.bgInner2"
                :src="data.bgInner2"
                class="alternate-dual-bg-right-img"
                alt="background image"
              />
              <img
                v-if="data.bgInner5"
                :src="data.bgInner5"
                class="alternate-dual-bg-right-img"
                alt="background image"
              />
              <img
                v-if="data.bgInner3"
                :src="data.bgInner3"
                class="alternate-dual-bg-right-img-1"
                alt="background image"
              />
              <div class="alternate-header-frames">
                <img
                  v-if="data.frame1"
                  :src="data.frame1"
                  class="alternate-bg-right-frame-1"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame2"
                  :src="data.frame2"
                  class="alternate-bg-right-frame-2"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame3"
                  :src="data.frame3"
                  class="alternate-bg-right-frame-3"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame4"
                  :src="data.frame4"
                  class="alternate-dual-bg-right-frame-1"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame5"
                  :src="data.frame5"
                  class="alternate-dual-bg-right-frame-2"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame6"
                  :src="data.frame6"
                  class="alternate-dual-bg-right-frame-3"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame7"
                  :src="data.frame7"
                  class="alternate-dual-bg-right-frame-5"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame8"
                  :src="data.frame8"
                  class="alternate-bg-right-frame-4"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame9"
                  :src="data.frame9"
                  class="alternate-bg-right-frame-5"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame10"
                  :src="data.frame10"
                  class="alternate-bg-right-frame-6"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame11"
                  :src="data.frame11"
                  class="alternate-bg-right-frame-7"
                  alt="Frame image"
                />
                <img
                  v-if="data.frame12"
                  :src="data.frame12"
                  class="alternate-bg-right-frame-8"
                  alt="Frame image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerMenu from "@/components/headerMenu.vue";

export default {
  props: ["data", "items"],
  components: {
    headerMenu,
  },
  methods: {
    goToDiv(id) {
      document.querySelector(id).scrollIntoView();
    },
  },
};
</script>

<style></style>
